"use client";

import { eventPublisher } from "@/services/event-publisher";
import { useSession } from "next-auth/react";
import { useEffect } from "react";

export default function ObservabilityInit() {
  const session = useSession();

  useEffect(() => {
    eventPublisher.initObservability();
  }, []);

  useEffect(() => {
    eventPublisher.setUser({
      email: session?.data?.user?.email ?? "",
      name: session?.data?.user?.name ?? "",
    });
  }, [session]);

  return null;
}
